var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.22485,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#5E6073"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.563 16.9218C25.9332 17.3075 26.0541 18.1833 26.0541 18.1833C26.0541 18.1833 26.1776 19.2121 26.1776 20.2405V21.2049C26.1776 22.2337 26.0541 23.2621 26.0541 23.2621C26.0541 23.2621 25.9332 24.1379 25.563 24.5236C25.1396 24.9799 24.6703 25.027 24.4049 25.0536C24.3758 25.0566 24.349 25.0593 24.3251 25.0622C22.5962 25.1909 20 25.1949 20 25.1949C20 25.1949 16.7877 25.1647 15.7992 25.067C15.7524 25.058 15.6956 25.051 15.6313 25.043C15.3183 25.0044 14.8268 24.9438 14.4367 24.5236C14.0664 24.1379 13.9459 23.2621 13.9459 23.2621C13.9459 23.2621 13.8224 22.2337 13.8224 21.2049V20.2405C13.8224 19.2121 13.9459 18.1833 13.9459 18.1833C13.9459 18.1833 14.0664 17.3075 14.4367 16.9218C14.8609 16.4649 15.3308 16.4183 15.5961 16.3919C15.6249 16.3891 15.6513 16.3865 15.6749 16.3836C17.4039 16.2549 19.9973 16.2549 19.9973 16.2549H20.0027C20.0027 16.2549 22.5962 16.2549 24.3251 16.3836C24.3488 16.3865 24.3751 16.3891 24.4039 16.3919C24.6691 16.4183 25.1391 16.465 25.563 16.9218ZM18.7241 18.8018L18.7245 22.3731L22.0622 20.5936L18.7241 18.8018Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.dd94e8c88c2716ad46c4bc0972f3b6b6.svg";
export { ForwardRef as ReactComponent };